import ServiceCard from "./ServiceCard";

// Small (800px) variants generated by scripts/optimize-images-services
const commercialImage = "/images/services/commercial.jpg";
const residentialImage = "/images/services/residential.jpg";
const industrialImage = "/images/services/industrial.jpg";

const services = [
  {
    title: "Commercial Painting",
    description: "Professional painting solutions for offices, retail spaces, and commercial properties.",
    image: commercialImage,
    href: "/commercial",
    disabled: false,
  },
  {
    title: "Residential Painting",
    description: "Transform your home with expert interior and exterior painting services.",
    image: residentialImage,
    href: "/residential",
    disabled: false,
  },
  {
    title: "Industrial Painting",
    description: "Specialized coatings and painting for industrial facilities and equipment.",
    image: industrialImage,
    href: "/industrial",
    disabled: true,
  },
];

const Services = () => {
  return (
    <section id="services" className="py-20 bg-background">
      <div className="section-container">
        <div className="text-center mb-12">
          <h2 className="section-heading font-heading">Our Services</h2>
          <p className="section-subheading mx-auto">
            From commercial properties to family homes, we deliver quality painting and contracting services across New Hampshire.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {services.map((service, index) => (
            <ServiceCard key={index} {...service} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
